
import React from 'react';
import { Button } from '@/components/ui/button';
import { Copy } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';
import { ReferralURLConfig } from '@/utils/config/types';
import { ReferralBanner } from '@/types/referral';

interface ReferralURLTestLinkProps {
  url: ReferralURLConfig;
}

const ReferralURLTestLink: React.FC<ReferralURLTestLinkProps> = ({ url }) => {
  const { toast } = useToast();

  const getTestReferralLink = (baseUrl: string, url: ReferralURLConfig) => {
    const urlObj = new URL(baseUrl);
    
    // Find the default banner if it exists
    const defaultBanner = url.banners?.find(banner => banner.isDefault);
    
    // Add the banner ID first if there's a default banner
    if (defaultBanner) {
      urlObj.searchParams.set('bid', defaultBanner.id);
    }
    
    // Add the referral code at the end
    urlObj.searchParams.set('ref', '0000000');
    
    return urlObj.toString();
  };

  const testLink = getTestReferralLink(url.baseUrl, url);

  return (
    <div className="bg-muted/50 p-3 rounded-md space-y-2">
      <div className="text-sm font-medium">Test Referral Link</div>
      <div className="flex items-center gap-2">
        <code className="flex-1 bg-background p-2 rounded text-xs overflow-x-auto">
          {testLink}
        </code>
        <Button
          variant="outline"
          size="sm"
          onClick={() => {
            navigator.clipboard.writeText(testLink);
            toast({
              title: "Copied",
              description: "Test referral link copied to clipboard"
            });
          }}
        >
          <Copy className="h-3 w-3" />
        </Button>
      </div>
      <div className="text-xs text-muted-foreground mt-1">
        {url.banners?.some(b => b.isDefault) ? 
          `Includes Banner: ${url.banners.find(b => b.isDefault)?.name || ''}` : 
          'No banner selected'}
      </div>
    </div>
  );
};

export default ReferralURLTestLink;
